export const toStripSlugs = ['flavor'];
